var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "float-right mr-4 mt-2"
  }, [_vm.accumulatedDecision === _vm.consts.DECISION_STATUS_APPROVED ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Deze blokkering is vrijgegeven omdat alle redenen zijn vrijgegeven`,
      expression: "`Deze blokkering is vrijgegeven omdat alle redenen zijn vrijgegeven`"
    }],
    staticClass: "fa fa-thumbs-up text-success"
  }) : _vm.accumulatedDecision === _vm.consts.DECISION_STATUS_DENIED ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Deze blokkering is definitief omdat 1 reden als negatief is beoordeeld, of omdat de gehele groep als definitief-blokkeren is ingesteld.`,
      expression: "`Deze blokkering is definitief omdat 1 reden als negatief is beoordeeld, of omdat de gehele groep als definitief-blokkeren is ingesteld.`"
    }],
    staticClass: "fa fa-thumbs-down text-danger"
  }) : _vm.accumulatedDecision === _vm.consts.DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Deze blokkering is irrelevant geworden omdat de data van de order is gewijzigd. De order wordt opnieuw gecontroleerd a.d.h.v. de nieuwe data.`,
      expression: "`Deze blokkering is irrelevant geworden omdat de data van de order is gewijzigd. De order wordt opnieuw gecontroleerd a.d.h.v. de nieuwe data.`"
    }]
  }, [_c('font-awesome-icon', {
    staticClass: "text-secondary",
    attrs: {
      "icon": "ban"
    }
  })], 1) : _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Nog niet alle redenen in deze blokkering zijn beoordeeld`,
      expression: "`Nog niet alle redenen in deze blokkering zijn beoordeeld`"
    }],
    staticClass: "text-secondary icon-dash"
  }, [_vm._v("-")])]), _vm.holdModelType === 'App\\Models\\Omt\\DispatchRequest' ? _c('div', [_c('b-card-title', {
    staticClass: "font-size-lg"
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.delivery')))])]), _c('strong', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.dispatch-requests.dispatcher-type')) + ": ")]), _vm._v(" " + _vm._s(_vm.holdReasonsForModel.dispatcher_type)), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.dispatch-requests.dispatcher-identifier')) + ":")]), _vm._v(" " + _vm._s(_vm.holdModel.dispatcher_identifier)), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.created-at')) + ":")]), _vm._v(" " + _vm._s(_vm.formatDateTime(_vm.holdModel.created_at))), _c('br'), _vm.holdModel.updated_at !== _vm.holdModel.created_at ? [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.updated-at')) + ": ")]), _vm._v(" " + _vm._s(_vm.formatDateTime(_vm.holdModel.updated_at))), _c('br')] : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.products')) + ":")]), _c('ul', {
    staticClass: "pl-4"
  }, _vm._l(_vm.getProductNamesForHoldModel(_vm.holdModel), function (name) {
    return _c('li', {
      key: name,
      domProps: {
        "innerHTML": _vm._s(name)
      }
    });
  }), 0)], 2) : _vm.holdModelType === 'App\\Models\\Omt\\SalesOrder' ? _c('div', [_c('b-card-title', {
    staticClass: "font-size-lg"
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.salesOrder')))])]), _c('strong')], 1) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("Onbekend type blokkering. Neem contact op met OmniStock.")])], 1), _c('b-alert', {
    staticClass: "mt-4 mb-0",
    attrs: {
      "show": _vm.hasNotApprovableReason,
      "variant": "info"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-info mr-2",
    attrs: {
      "icon": "circle-info"
    }
  }), _vm._v(" Deze blokkering kan niet vrijgegeven worden. In plaats daarvan kan je de data van de order wijzigen. Hierna wordt de order opnieuw beoordeeld. ")], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }